import { render, staticRenderFns } from "./TeacherHome.vue?vue&type=template&id=6f2da272&scoped=true&"
import script from "./TeacherHome.vue?vue&type=script&lang=js&"
export * from "./TeacherHome.vue?vue&type=script&lang=js&"
import style0 from "./TeacherHome.vue?vue&type=style&index=0&id=6f2da272&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2da272",
  null
  
)

export default component.exports